import React from 'react';
import { Button } from '@scuf/common';

import './IconTabbedSwitchTheme.scss';
import { ITextTabbedSwitchProps } from '../TextTabbedSwitch/TextTabbedSwitch';

export interface IIconTabbedSwitchProps extends ITextTabbedSwitchProps {
  tabList: {
    id: string;
    label: string;
    iconSVG?: string;
    iconInactiveSVG?: string;
  }[];
  hideInactiveText?: boolean;
}

export const IconTabbedSwitch = (props: IIconTabbedSwitchProps) => {
  const {
    activeTab,
    onTabChange,
    tabList,
    groupClassName,
    tabClassName,
    hideInactiveText
  } = props;
  return (
    <Button.Group
      className={`tabbed-switch-group-text-icon ${groupClassName || ''}`}
    >
      {tabList.map((val, _idx) => (
        <Button
          icon={
            <img
              className={`tabbed-switch-icon ${
                activeTab === val.id ? 'active' : 'inactive'
              }`}
              src={
                activeTab === val.id
                  ? val.iconSVG
                  : val.iconInactiveSVG || val.iconSVG
              }
            />
          }
          key={`${val.id}-tabbed-switch-${_idx}`}
          className={`tabbed-switch-text-icon ${tabClassName || ''} ${
            activeTab === val.id ? 'active' : 'inactive'
          }`}
          type={activeTab == val.id ? 'inline' : 'inline-secondary'}
          content={hideInactiveText && activeTab !== val.id ? '' : val.label}
          onClick={() => {
            onTabChange(val.id);
          }}
        />
      ))}
    </Button.Group>
  );
};
